import { render, staticRenderFns } from "./ModalAuthorizeQuotation.vue?vue&type=template&id=04079792&lang=pug&"
import script from "./ModalAuthorizeQuotation.vue?vue&type=script&lang=js&"
export * from "./ModalAuthorizeQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports